"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCustoTree = void 0;
const components_1 = require("../components");
const texts_1 = require("../texts");
const hook_1 = require("../hook");
const react_flexible_contexts_1 = require("react-flexible-contexts");
const interfaces_1 = require("../../interfaces");
const data_1 = require("../data");
const prop_1 = require("../../utils/prop");
const components_2 = require("./components");
const texts_2 = require("./texts");
const data_2 = require("./data");
const hook_2 = require("./hook");
const utils_1 = require("../../utils");
const getArgs = (args) => {
    if (args[0] instanceof react_flexible_contexts_1.StackedContext) {
        return {
            obj: args[0].context.modifiedDefaultValueGetter().value,
            useSelector: args[0].context.useSelector,
            options: args[1] || {},
        };
    }
    return { obj: args[0], useSelector: args[1], options: args[2] || {} };
};
function buildCustoTree(...args) {
    const { obj, useSelector, options } = getArgs(args);
    const defaultValuesByTypes = options.defaultValuesByTypes || {};
    const prefixes = options.prefixes || ["value"];
    const helper = (prefixes, obj, defaultValue, final = {}) => {
        for (const key in obj) {
            const val = obj[key];
            const defVal = defaultValue ? defaultValue[key] : undefined;
            const getVal = () => useSelector(x => prop_1.untypedGetProp(x, ...prefixes, key), []);
            const path = [...prefixes, key].join(".");
            if (val === interfaces_1.CustoType.component ||
                val instanceof components_1.CustoComponent ||
                (val instanceof hook_1.CustoHook && val.type === interfaces_1.CustoType.component)) {
                // Component
                final[key] = components_2.buildCustoComponent(getVal, path, defVal || defaultValuesByTypes[interfaces_1.CustoType.component]);
            }
            else if (val === interfaces_1.CustoType.text ||
                val instanceof texts_1.CustoText ||
                (val instanceof hook_1.CustoHook && val.type === interfaces_1.CustoType.text)) {
                // Text
                final[key] = texts_2.buildCustoText(getVal, options.getTextTransformationHook, path, defVal || defaultValuesByTypes[interfaces_1.CustoType.text]);
            }
            else if (val === interfaces_1.CustoType.data ||
                val instanceof data_1.CustoData ||
                (val instanceof hook_1.CustoHook && val.type === interfaces_1.CustoType.data)) {
                // Data
                final[key] = data_2.buildCustoData(getVal, path, defVal || defaultValuesByTypes[interfaces_1.CustoType.data]);
            }
            else if (val === interfaces_1.CustoType.hook ||
                (val instanceof hook_1.CustoHook && val.type === interfaces_1.CustoType.hook)) {
                // Hook
                final[key] = hook_2.buildCustoHook(getVal, path, defVal || defaultValuesByTypes[interfaces_1.CustoType.hook]);
            }
            else if (utils_1.isCustoClass(val)) {
                //
            }
            else {
                final[key] = {};
                helper([...prefixes, key], obj[key], defaultValue ? defaultValue[key] : undefined, final[key]);
            }
        }
        return final;
    };
    const result = helper(prefixes || [], obj, options.defaultValue);
    return result;
}
exports.buildCustoTree = buildCustoTree;
